import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';

export const MISSION_CONTROL_GOAL_CREATORS_URL = '/i/goalCreators';

export type QueryGoalCreatorsResponse = {
  goalCreators: {
    id: string;
    fullName: string;
  }[];
};

export type UseQueryGoalCreatorsState = ReturnType<typeof useQueryGoalCreators>;

export const useQueryGoalCreators = (
  params?: Record<string, unknown>,
  options?: RestQueryHookOptions<QueryGoalCreatorsResponse>,
) => {
  const {
    data,
    isLoading,
    error: errorMessage,
    isError: hasError,
    refetch,
  } = useRestQuery<QueryGoalCreatorsResponse>(MISSION_CONTROL_GOAL_CREATORS_URL, params, options);

  return {
    goalCreators: data?.goalCreators || [],
    isLoading,
    hasError,
    errorMessage,
    refetch,
  };
};
